import { Cart } from "@commercetools/platform-sdk"
import React, { useEffect, useState } from "react"
import { Box } from "theme-ui"
import { useCartService } from "../cart/CartServiceHook"
import { useApplePay } from "../FeatureFlags"
import { SKU } from "../product/VariantProxy"
import { ApplePayExpress } from "./ApplePayExpress"
import {
  useBrowserPaymentSupport,
  AdyenPaymentMethodType
} from "./payment/validation/AdyenPaymentValidation"

export const ExpressCheckout: React.FC<{
  sku?: SKU
  cart?: Cart
}> = ({ sku, cart }) => {
  const browser = useBrowserPaymentSupport()
  const [expressCart, setExpressCart] = useState<Cart | undefined>(cart)
  const applePayEnabled = useApplePay()
  const cartService = useCartService()

  useEffect(() => {
    if (sku) {
      cartService.createExpressCart(sku).then(setExpressCart)
    }
  }, [sku])

  const expressCheckoutOptions: {
    applepay: (index: number) => React.JSX.Element | null
  } = {
    applepay: (index: number) =>
      applePayEnabled ? (
        <ApplePayExpress key={`applepay-${index}`} cart={expressCart} />
      ) : null
  }

  const supportedExpressCheckoutOptions = Object.entries(
    expressCheckoutOptions
  ).filter(([key]) => browser.supports(key as AdyenPaymentMethodType))
  // .filter(([key]) => true)

  return supportedExpressCheckoutOptions.length === 0 ? null : (
    <Box sx={{ paddingTop: 10 }}>
      {supportedExpressCheckoutOptions.map(([_, fn], index) => fn(index))}
    </Box>
  )
}
